import { render, staticRenderFns } from "./charger-type-list.vue?vue&type=template&id=70f4cf45"
import script from "./charger-type-list.vue?vue&type=script&lang=js"
export * from "./charger-type-list.vue?vue&type=script&lang=js"
import style0 from "./charger-type-list.vue?vue&type=style&index=0&id=70f4cf45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports